import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { makeStyles, Tabs, Tab, Toolbar } from '@material-ui/core'
import { useFlag } from '@unleash/proxy-client-react'

import { ReactComponent as ListenMetricIcon } from 'app/components/icons/listen-metric-icon.svg'
import { ReactComponent as DeliverMetricsIcon } from 'app/components/icons/deliver-metrics-icon.svg'
import { ReactComponent as ViewRateMetricsIcon } from 'app/components/icons/view-rate-metrics-icon.svg'
import { ReactComponent as ReactionMetricsIcon } from 'app/components/icons/reaction-metrics-icon.svg'

import DeliveryRate from './DeliveryRate'
import ViewRate from 'app/main/messages/timeline/Metrics/ViewRate'
import useMetrics from 'app/main/messages/timeline/Metrics/useMetrics'
import UserReaction from 'app/main/messages/timeline/Metrics/UserReaction'
import TextToSpeech from 'app/main/messages/timeline/Metrics/TextToSpeech'
import MetricsHeaderBackground from './MetricsHeaderBackground'
import NewMetrics from './NewMetrics'

const useStyles = makeStyles((theme) => ({
  appBar: {
    boxShadow: 'unset',
    borderBottom: `1px solid ${theme.palette.neutrals['200']}`,
    width: '100%',
    zIndex: 99,
  },
  toolBar: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#000000',
    backgroundColor: '#FFFFFF',
    minHeight: 'unset',
    padding: 0,
    height: 'fit-content !important',

    '& .MuiTabs-root': {
      width: '100%',
    },
    '& .MuiTab-root': {
      minWidth: 'fit-content',
      textTransform: 'capitalize',
      backgroundColor: theme.colors['primary-lighter'],
      margin: '0 .5rem',
      fontWeight: '500',
      fontSize: '14px',
      color: theme.colors.primary,
      opacity: 'unset',
    },
    '& .MuiTab-root:first-child': {
      marginLeft: 0,
    },
    '& .MuiTab-root:last-child': {
      marginRight: 0,
    },
    '& .MuiTabs-scroller > span': {
      display: 'none',
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
      border: `1px solid ${theme.colors.secondary}`,
      borderRadius: '4px',
    },
    '& .MuiTabs-flexContainer': {
      width: '100%',
      overflow: 'auto',
    },
  },
}))

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        width: '100%',
        backgroundColor: '#FDFDFD',
        border: '1px solid #E8E8E8',
        marginTop: '1rem',
      }}
    >
      {children}
    </div>
  )
}

const Metrics = ({ id }) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const mes_3739_improve_metrix = useFlag('mes_3739_improve_metrix')

  const {
    state: {
      deliverMetrics,
      viewMetrics,
      userReactionMetrics,
      textToSpeechMetrics,
      isLoading,
    },
    fetchDeliverMetrics,
    fetchViewMetrics,
    fetchUserReactionMetrics,
    fetchTextToSpeechMetrics,
  } = useMetrics(id)

  const [state, setState] = useState(0)

  const handleFetchMetric = (value) => {
    switch (value) {
      case 0:
        fetchDeliverMetrics()
        break
      case 1:
        fetchViewMetrics()
        break
      case 2:
        fetchUserReactionMetrics()
        break
      case 3:
        fetchTextToSpeechMetrics()
        break
      default:
    }
  }

  const handleChange = (event, newValue) => {
    setState(newValue)
    handleFetchMetric(newValue)
  }

  const handleFetchDeliverMetrics = () => {
    fetchDeliverMetrics()
  }

  useEffect(() => {
    if (!mes_3739_improve_metrix) {
      handleFetchDeliverMetrics()
    }
  }, [mes_3739_improve_metrix])

  if (mes_3739_improve_metrix) {
    return <NewMetrics id={id} />
  }

  return (
    <>
      <Toolbar className={classes.toolBar}>
        <Tabs
          value={state}
          variant="fullWidth"
          onChange={handleChange}
          aria-label="Metrics"
        >
          <Tab
            label={formatMessage({
              id: 'metrics.delivery.rate',
            })}
            icon={<DeliverMetricsIcon />}
            id="Metrics-Delivery-Rate"
            aria-controls="Metrics-Delivery-Rate"
          />
          <Tab
            label={formatMessage({
              id: 'metrics.view.rate',
            })}
            icon={<ViewRateMetricsIcon />}
            id="Metrics-View-Rate"
            aria-controls="Metrics-View-Rate"
          />
          <Tab
            label={formatMessage({
              id: 'metrics.user.reaction',
            })}
            icon={<ReactionMetricsIcon />}
            id="Metrics-User-Reaction"
            aria-controls="Metrics-User-Reaction"
          />
          <Tab
            label={formatMessage({
              id: 'metrics.listen',
            })}
            icon={<ListenMetricIcon />}
            id="Metrics-Listen"
            aria-controls="Metrics-Listen"
          />
        </Tabs>
      </Toolbar>
      <TabPanel value={state} index={0}>
        <DeliveryRate data={deliverMetrics} isLoading={isLoading} />
      </TabPanel>
      <TabPanel value={state} index={1}>
        <ViewRate data={viewMetrics} />
      </TabPanel>
      <TabPanel value={state} index={2}>
        <UserReaction data={userReactionMetrics} />
      </TabPanel>
      <TabPanel value={state} index={3}>
        <TextToSpeech data={textToSpeechMetrics} />
      </TabPanel>
    </>
  )
}

export default Metrics
